<template>
  <div class="index">
    <div class="headTitle">
      <div class="banner"></div>
      <div class="userInfo">
        <div class="userInfo_title">个人信息</div>
        <div class="userInfo_update">
          <el-button @click="update_infobtn">信息修改</el-button>
        </div>
        <div class="userInfo_content">
          <div class="userInfo_icon" v-show="src != null">
            <img :src= src alt="">
<!--            <el-avatar shape="square" :src="src"></el-avatar>-->
          </div>
          <div class="userInfo_right">
            <div class="userInfo_line">
              <div class="userInfo_str">姓 名<span></span></div>
              <div class="userInfo_val">{{global.user_info.name}}<span></span></div>
            </div>
            <div class="userInfo_line">
              <div class="userInfo_str">岗 位<span></span></div>
              <div class="userInfo_val">{{stationName()}}({{branchName()}})<span></span></div>
            </div>
            <div class="userInfo_line">
              <div class="userInfo_str">学 时<span></span></div>
              <div class="tokinaga">
                {{learnTime}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menuContent">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <!-- 信息修改弹窗 -->
    <div>
      <el-dialog title="信息修改" :visible.sync="update_info" width="25%">
        <el-form :model="info" :rules="rules" ref="ruleForm">
          <el-form-item label="姓名：" :label-width="label_width" prop="name">
            <el-input autocomplete="off" v-model="info.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别：" :label-width="label_width">
            <el-select v-model="info.sex" clearable>
              <el-option
                v-for="item in sexOptions "
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄：" :label-width="label_width" prop="age">
            <el-input autocomplete="off" v-model="info.age" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机：" :label-width="label_width" prop="phone">
            <el-input autocomplete="off" v-model="info.phone" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="update_pwdbtn">修改密码</el-button>
          <el-button @click="update_info = false">取 消</el-button>
          <el-button type="primary" @click="submit('ruleForm')">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 密码修改弹窗 -->
    <div>
      <el-dialog title="密码修改" :visible.sync="update_pwd" width="25%">
        <el-form :model="pwdinfo" :rules="rules" ref="ruleFormpwd">
          <el-form-item label="旧密码：" prop="Theoldpwd" :label-width="label_width">
            <el-input autocomplete="off" v-model="pwdinfo.Theoldpwd" type="password" clearable placeholder="8到16个字符,大小写字母或数字"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newpwd" :label-width="label_width">
            <el-input autocomplete="off" v-model="pwdinfo.newpwd" type="password" clearable placeholder="8到16个字符,大小写字母或数字"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="confirmpwd" :label-width="label_width">
            <el-input autocomplete="off" v-model="pwdinfo.confirmpwd" type="password" clearable placeholder="8到16个字符,大小写字母或数字"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="update_pwdbtn">返 回</el-button>
          <el-button @click="resetForm('ruleFormpwd')">重 置</el-button>
          <el-button @click="update_pwd = false">取 消</el-button>
          <el-button type="primary" @click="submitpwd('ruleFormpwd')">提 交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
export default {
  data () {
    return {
      // 信息修改弹窗
      update_info: false,
      // 密码修改弹窗
      update_pwd: false,
      label_width: '120px',
      info: {
        name: '',
        sex: '',
        age: '',
        phone: ''
      },
      pwdinfo: {
        Theoldpwd: '',
        newpwd: '',
        confirmpwd: ''
      },
      sexOptions: [
        {
          value: true,
          label: '男'
        },
        {
          value: false,
          label: '女'
        }
      ],
      rules: {
        name: [
          { required: true, trigger: 'blur', message: '请输入用户名' },
          {min: 1, max: 30, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9_]{1,30}$/, message: '请输入用户名, 限中英文数字,不超过30'}
        ],
        age: [
          { trigger: 'blur', required: false },
          {pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '请输入正确格式的年龄'}
        ],
        phone: [
          { trigger: 'blur' },
          {pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确格式的手机号'}
        ],
        Theoldpwd: [
          {required: true, trigger: 'blur', message: '请输入旧密码'},
          { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        ],
        newpwd: [
          {required: true, trigger: 'blur', message: '请输入新密码'},
          { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        ],
        confirmpwd: [
          {required: true, trigger: 'blur', message: '请再次输入密码'},
          { min: 8, max: 16, pattern: /^[0-9a-zA-Z]{8,16}$/, message: '密码格式错误, 长度8到16字符,包含大小写字母和数字', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    src: function () {
      let userImg = this.global.user_info.user_img
      if (!userImg) {
        return null
      }
      let iconUrl = this.global.iconUrl
      return iconUrl + userImg
    },
    learnTime: function () {
      let time = this.global.user_info.learn_time
      return this.formateSeconds(time)
    }
  },
  mounted () {
  },
  methods: {
    stationName () {
      let stationList = this.global.stationList
      let id = this.global.user_info.station_id
      return this.global.getName(stationList, id, 'station')
    },
    branchName () {
      let branchList = this.global.branchList
      let id = this.global.user_info.branch_id
      return this.global.getName(branchList, id, 'branch')
    },
    // 将秒转化为时分
    formateSeconds (endTime) {
      if (endTime === null) {
        return '0 分'
      }
      let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
      let min = 0 // 初始化分
      let h = 0 // 初始化小时
      let result = ''
      if (secondTime > 59) { // 如果秒数大于59，将秒数转换成整数
        min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
        if (min > 60) { // 如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, '0')} 小时 ${min.toString().padStart(2, '0')}分`
      return result
    },
    update_infobtn () {
      this.update_info = !this.update_info
      let userInfo = window.$global.user_info
      let info = this.info
      info.name = userInfo.name
      info.sex = userInfo.sex
      info.age = userInfo.age
      info.phone = userInfo.phone
    },
    update_pwdbtn () {
      this.update_info = !this.update_info
      this.update_pwd = !this.update_pwd
    },
    submit (data) {
      // let obj = {}
      // this.info.pwd = this.$md5(this.info.pwd)
      // obj.data = this.info
      this.$refs[data].validate((valid) => {
        if (valid) {
          this.setinfo()
        } else {
          return false
        }
      })
    },
    submitpwd (data) {
      if (this.pwdinfo.newpwd !== this.pwdinfo.confirmpwd) {
        this.$message({
          message: '两次密码不一致, 请重新输入',
          type: 'warning'
        })
        this.pwdinfo.newpwd = ''
        this.pwdinfo.confirmpwd = ''
        return
      }
      this.$refs[data].validate((valid) => {
        if (valid) {
          this.setpwd()
        } else {
          return false
        }
      })
    },
    resetForm (data) {
      this.$refs[data].resetFields()
    },
    // 信息修改提交
    setinfo () {
      let info = this.info
      info.id = window.$global.user_info.id
      let obj = {}
      obj.data = info
      obj.vm = this
      obj.fn = this.resinfo
      req.Post('user/update_UserData', obj)
    },
    // 信息修改提交回调
    resinfo (data) {
      console.log(data)
      if (data.err_code === 0) {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.update_info = !this.update_info
        let userInfo = window.$global.user_info
        let info = this.info
        userInfo.name = info.name
        userInfo.sex = info.sex
        userInfo.age = info.age
        userInfo.phone = info.phone
      } else {
        this.$message({
          message: '修改失败',
          type: 'warning'
        })
      }
    },
    // 密码修改提交
    setpwd () {
      let pwdinfo = this.pwdinfo
      let upPwd = {}
      upPwd.Theoldpwd = this.$md5(pwdinfo.Theoldpwd)
      upPwd.newpwd = this.$md5(pwdinfo.newpwd)
      upPwd.id = window.$global.user_info.id
      let obj = {}
      obj.data = upPwd
      obj.vm = this
      obj.fn = this.reqpwd
      req.Post('user/update_Pwd', obj)
    },
    reqpwd (data) {
      let pwdinfo = this.pwdinfo
      console.log(data)
      if (data.type === '成功') {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: '旧密码不正确',
          type: 'warning'
        })
        pwdinfo.Theoldpwd = ''
        return
      }
      pwdinfo.Theoldpwd = ''
      pwdinfo.newpwd = ''
      pwdinfo.confirmpwd = ''
      this.update_pwd = !this.update_pwd
    }
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headTitle{
  width: 100%;
  height: 33%;
  display: flex;
  /* border: 1px solid; */
}
.banner{
  width: 75%;
  height: 100%;
  background-image: url(../assets/bg/banna.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -o-background-size: cover;
}
.userInfo{
  width: 560px;
}
.userInfo_title{
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.userInfo_content{
  height: 70%;
  width: 90%;
  margin: auto;
  display: flex;
}
.userInfo_right{
  width: 56%;
  margin: auto;
}
.userInfo_update{
  margin-left: 25rem;
}
.userInfo_icon{
  width: 35%;
  margin-right: 15px;
  margin-bottom: 15px;
  border: 1px solid rgb(167, 167, 167);
}
.userInfo_icon > img{
  width: 100%;
  height: 100%;
}
.userInfo_line{
  height: 40px;
  align-items: center;
  display: flex;
}
.userInfo_str{
  width: 30%;
  text-align: justify;
}
.userInfo_val{
  margin-left: 15%;
  width: 50%;
  text-align: justify;
}
.userInfo_val > span {
  display: inline-block;
  padding-left: 100%;
}
.userInfo_str > span {
  display: inline-block;
  padding-left: 100%;
}
.tokinaga{
  margin-left: 40px;
  font-size: 22px;
  color: #00aaff;
}
.menuContent{
  width: 100%;
  height: 66.5%;
  background-color: #e5e5e5;
}
.index{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue